"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalTypeByDecorator = exports.getClsTypeByDecorator = exports.getReflectMetadata = void 0;
var getGlobalType_1 = require("./getGlobalType");
try {
    require('reflect-metadata');
}
catch (error) { }
function getReflectMetadata(metadataKey, target, key) {
    /* istanbul ignore else */
    if (Reflect && Reflect.getMetadata) {
        return Reflect.getMetadata(metadataKey, target, key);
    }
}
exports.getReflectMetadata = getReflectMetadata;
function getClsTypeByDecorator(type, target, key) {
    if (type === undefined) {
        type = getReflectMetadata('design:type', target, key);
    }
    return type;
}
exports.getClsTypeByDecorator = getClsTypeByDecorator;
function getGlobalTypeByDecorator(type, target, key) {
    return (0, getGlobalType_1.getGlobalType)(getClsTypeByDecorator(type, target, key));
}
exports.getGlobalTypeByDecorator = getGlobalTypeByDecorator;
//# sourceMappingURL=getByDecorator.js.map